import { useState } from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardBody } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const WhatDo = ({ heading_img, heading, button, items, fn }) => {
    const [selected, setSelected] = useState(null);

    return (
        <div className="component-whatdo">
            <div className="row">
                <HeadingOne className="col" image={heading_img} heading={heading} />
            </div>
            <Card>
                <CardBody className="!py-20">
                    <div className="grid grid-cols-3">
                        {items?.map((item, index) => (
                            <div className="col-span-3 lg:col-span-1">
                                <div
                                    className={'cursor-pointer rounded-[28px] p-12 ' + (selected === index ? 'bg-cyan-700' : 'bg-transparent')}
                                    onClick={() => setSelected(index)}
                                >
                                    <div className={'flex h-72 flex-col items-center justify-between rounded-[20px] border border-white/20 p-4'}>
                                        <div className="mx-auto size-36 overflow-hidden rounded-full">
                                            <img src={item.image} alt={item.text} className="h-full w-full object-cover object-top" />
                                        </div>
                                        <div className="flex h-18 items-center text-center font-bold">{item.text}</div>
                                    </div>
                                    <div className={'mt-8 flex justify-center ' + (selected === index ? '' : 'hidden')}>
                                        <Button {...item.button} onClick={() => fn.handleAction(item.button.action)} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default WhatDo;
